import * as React from 'react';
import { GetServerSideProps } from 'next';

import { WorkerReferences } from '../../components/worker-references';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IWorkerReferencesPageProps {}

const WorkerReferencesPage: React.FunctionComponent<IWorkerReferencesPageProps> = (props) => <WorkerReferences />;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'worker-references-page', 'onboarding-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};

export default WorkerReferencesPage;
